import React from 'react';

import AccordionContainer from '../blocks/accordion/AccordionContainer';

export default class WorkShopModules extends React.Component {
  render() {

    return (<main className="main-content">
      <div className="container-fluid">
        <div className="row regular-workshop">
          <div className="col-12 col-md-3 push-md-9">
            <div className="regular-workshop-sidebar">
              <div className="workshop-card-module hide-xs hide-s">
                <p className="workshop-card-module-title">WORKSHOP INCLUDES 4 MODULES:</p>
                <ul className="workshop-card-module-list">
                  <li className="workshop-card-module-item ">
                    <span className="workshop-card-module-number">1</span>
                    <span className="workshop-card-module-caption">Atrial Fibrillation Theory</span>
                  </li>
                  <li className="workshop-card-module-item active">
                    <span className="workshop-card-module-number">2</span>
                    <span className="workshop-card-module-caption">Diagnosing and Managing Atrial Fibrillation</span>
                  </li>
                  <li className="workshop-card-module-item">
                    <span className="workshop-card-module-number">3</span>
                    <span className="workshop-card-module-caption">Atrial Fibrillation & Stroke</span>
                  </li>
                  <li className="workshop-card-module-item">
                    <span className="workshop-card-module-number">4</span>
                    <span className="workshop-card-module-caption">Patient Cases</span>
                  </li>
                </ul>
              </div>
              <div className="regular-workshop-logo-holder regular-workshop-holder">
                <div className="regular-workshop-logo">
                  <img src="../img/card-ava.jpg" alt="logo"/>
                </div>
                <div className="regular-workshop-logo-info">
                  <p className="regular-workshop-logo-provide">PROVIDED BY</p>
                  <p className="regular-workshop-logo-company-name">Michael O'Carroll</p>
                  <span className="btn regular-workshop-logo-btn bordered">provider info</span>
                </div>
              </div>
              <div className="regular-workshop-summary regular-workshop-holder">
                <p className="regular-workshop-holder-title">SUMMARY</p>

                <ul className="regular-workshop-summary-text-holder">
                  <li><span className="regular-workshop-summary-title">AUDIENCE:</span>
                    <span className="regular-workshop-summary-text">6</span></li>
                </ul>
                <ul className="regular-workshop-summary-text-holder">
                  <li>
                    <span className="regular-workshop-summary-title">modules:</span>
                    <span className="regular-workshop-summary-text">12h</span>
                  </li>
                  <li>
                    <span className="regular-workshop-summary-title">CPD:</span>
                    <span className="regular-workshop-summary-text">12h</span>
                  </li>
                  <li>
                    <span className="regular-workshop-summary-title">PRICE:</span>
                    <span className="regular-workshop-summary-text">
                      <span className="currency euro"></span>65</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-9 pull-md-3">
            <div className="regular-workshop-content">
              <div className="workshop-module gutter">
                <div className="accordion">
                  <AccordionContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>)
  }
}



// WEBPACK FOOTER //
// ./src/components/WorkShopModules.jsx